@if (member(); as currentMember) {
  <div class="sp-overlay" (click)="onClose()">
    <div
      class="sp-dialog"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'Email preferences for ' + currentMember.name"
      (click)="$event.stopPropagation()"
    >
      <header class="sp-head">
        <div class="sp-head-text">
          <div class="sp-title">Email preferences</div>
          <div class="sp-subtitle">{{ currentMember.name }} · {{ currentMember.email }}</div>
        </div>
        <button class="sp-close" type="button" (click)="onClose()" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </header>

      <div class="sp-body">
        @if (loading()) {
          <p class="sp-muted">Loading…</p>
        } @else if (preferences(); as currentPreferences) {
          <label class="sp-toggle">
            <span class="sp-toggle-text">
              <span class="sp-toggle-label">This project</span>
              <span class="sp-toggle-desc">Emails about this project.</span>
            </span>
            <input
              type="checkbox"
              role="switch"
              [checked]="currentPreferences.projectEnabled"
              [disabled]="saving()"
              (change)="setPreference('projectEnabled', $any($event.target).checked)"
            />
          </label>
          <label class="sp-toggle">
            <span class="sp-toggle-text">
              <span class="sp-toggle-label">All emails</span>
              <span class="sp-toggle-desc">Emails about every project. Turned off when someone opts out of all emails.</span>
            </span>
            <input
              type="checkbox"
              role="switch"
              [checked]="currentPreferences.allEnabled"
              [disabled]="saving()"
              (change)="setPreference('allEnabled', $any($event.target).checked)"
            />
          </label>
        }
        @if (error()) {
          <p class="sp-error">{{ error() }}</p>
        }
      </div>
    </div>
  </div>
}
